/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OAuthAppConfigsPatchSpec { 
    /**
     * Whether the OAuth app secrets are rotatable or not
     */
    rotatable?: boolean;
    /**
     * Secret expiry days
     */
    secret_expiry_days?: number;
}

